export default __webpack_public_path__ + "c54ac55e53bd8129d4c7685d39d37d31.png";